import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import uploadImg from "../../../images/cloud-upload-regular-240.png";
import fileDefault from "../../../images/file-blank-solid-240.png";
import fileExcel from "../../../images/excel.png";
import "./DropFile.css";
import { ThreeCircles } from "react-loader-spinner";

export const ImageConfig = {
  default: fileDefault,
  xlsx: fileExcel,
  xls: fileExcel,
};

const DropFileInput = (props) => {
  const { disabled = false } = props;
  const wrapperRef = useRef(null);

  const [fileList, setFileList] = useState([]);
  const [maxFilesWarning, setMaxFilesWarning] = useState(false);

  const onDragEnter = () => {
    if (disabled) return;
    wrapperRef.current.classList.add("dragover");
  };

  const onDragLeave = () => {
    if (disabled) return;
    wrapperRef.current.classList.remove("dragover");
  };

  const onDrop = () => {
    if (disabled) return;
    wrapperRef.current.classList.remove("dragover");
    wrapperRef.current.classList.add("dropped");
  };

  const MAX_FILES = 10;

  const onFileDrop = (e) => {
    if (disabled) return;
    const selected = Array.from(e.target.files);
    if (!selected.length) return;

    let updatedList;
    if (props && props.fileLimit && props.fileLimit === "single") {
      updatedList = [selected[0]];
      setMaxFilesWarning(false);
    } else {
      const combined = [...fileList, ...selected];
      if (combined.length > MAX_FILES) {
        updatedList = combined.slice(0, MAX_FILES);
        setMaxFilesWarning(true);
      } else {
        updatedList = combined;
        setMaxFilesWarning(false);
      }
    }
    props.onFileChange(updatedList, e);
    setFileList([]);
  };

  useEffect(() => {
    if (!props.uploading) {
      setFileList([]);
      setMaxFilesWarning(false);
    }
  }, [props.uploading]);

  const fileRemove = (file) => {
    if (disabled) return;
    const updatedList = [...fileList];
    updatedList.splice(fileList.indexOf(file), 1);
    setFileList(updatedList);
    props.onFileChange(updatedList);
  };

  return (
    <>
      <div
        ref={wrapperRef}
        className={`drop-file-input ${disabled ? "drop-file-input--disabled" : ""}`}  // Add disabled class
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        {props.uploading && fileList.length > 0 ? (
          fileList.map((item, index) => (
            <div key={index} className="drop-file-input__label">
              <div className="uploading-animation">
                <div>
                  <ThreeCircles
                    height="30"
                    width="30"
                    color="#4fa94d"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel="three-circles-rotating"
                    outerCircleColor="var(--theme1_tertiary)"
                    innerCircleColor="var(--theme1_secondary)"
                    middleCircleColor="var(--theme1_primary)"
                  />
                </div>
                <div>
                  <p>Uploading your file...</p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="drop-file-input__label">
            <img src={uploadImg} alt="" />
            <p>{disabled ? "Upload disabled" : (props.message || "Drag and drop your file here")}</p>
          </div>
        )}

        <input
          type="file"
          value=""
          onChange={onFileDrop}
          accept={props.accept}
          disabled={disabled}
          multiple={!props.fileLimit || props.fileLimit !== "single"}
        />
      </div>
      {maxFilesWarning && (
        <p style={{ color: "#b45309", fontSize: "0.78rem", marginTop: "4px", marginBottom: 0 }}>
          Max 10 files allowed — only the first 10 were added.
        </p>
      )}
    </>
  );
};

DropFileInput.propTypes = {
  onFileChange: PropTypes.func,
  disabled: PropTypes.bool,
  uploading: PropTypes.bool,
  message: PropTypes.string,
  fileLimit: PropTypes.oneOf(["single", "multiple"]),
  accept: PropTypes.string,
};

export default DropFileInput;